<template>
  <div class="cs-status-bar">
    <ProgressBar :completed="completedPercentage" bgcolor="orange"></ProgressBar>
  </div>
</template>
<script>

import ProgressBar from "@/components/ProgressBar";

export default {
  props: [ 'cost', 'progress' ],
  components: { ProgressBar },

  computed: {
    formattedCost() {
      return ' $' + this.cost;
    },
    completedPercentage() {
      if (this.progress.total === 0) {
        return 0; // Avoid dividing by zero
      }

      const percentage = Math.floor((this.progress.completed / this.progress.total) * 100);
      return percentage;
    },
    done() {
      return this.progress.completed === this.progress.total;
    }

  },
};
</script>

<style lang="scss">
@import 'src/scss/status-bar.scss';
</style>
